import React from 'react'
import SimplePage from '../../pages/SimplePage'
import SkinPage from '../../pages/SkinPage'
import DotSelectPage from '../../pages/DotSelectPage'
import StartPage from '../../pages/StartPage'
import SummaryPage from '../../pages/SummaryPage'
import Modal from '../../components/Modal'
import './QuizWrapper.css'

const INITIAL_STATE = {
  currPage: 1,
  gender: 1,
  age: 1,
  skinType: 1,
  purpose: 0,
  toggledBoxes: [],
  selectedTreatments: [],
  conditions: [],
  content:
    process.env.NODE_ENV === 'development'
      ? require('../../content.json')
      : document.quizData,
  modalOpen: false,
  modalContent: <span> test </span>,
  search: '',
}

class QuizWrapper extends React.Component {
  constructor() {
    super()
    this.state = INITIAL_STATE
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currPage !== this.state.currPage) {
      if (process.env.NODE_ENV !== 'production') {
        document.getElementById('VenusQuizApplication').scrollIntoView()
      } else {
        const quizWrapperElement = document.getElementById('venusQuiz')
        if (quizWrapperElement) {
          quizWrapperElement.scrollIntoView()
        }
      }
    }
  }

  onSubmitSearch() {
    window.location = this.props.data.searchURLPrefix + this.state.search
  }

  render() {
    const {
      currPage,
      content,
      gender,
      modalOpen,
      modalContent,
      skinType,
    } = this.state
    const data = content.find(e => e.page === currPage)
    return (
      <React.Fragment>
        {modalOpen && (
          <Modal
            setWrapperState={e => this.setState(e)}
            wrapperState={this.state}
          >
            {modalContent}
          </Modal>
        )}
        <div className={'QuizWrapper' + (modalOpen ? ' blurred' : '')}>
          {data && data.type === 'simpleForm' && (
            <SimplePage
              setWrapperState={e => this.setState(e)}
              wrapperState={this.state}
              data={data}
              summaryContent={content.find(e => e.page === 10)}
            />
          )}
          {data && data.type === 'skinSelect' && (
            <SkinPage
              setWrapperState={e => this.setState(e)}
              gender={gender}
              data={data}
              skinType={skinType}
            />
          )}
          {data && data.type === 'startPage' && (
            <StartPage
              setWrapperState={e => this.setState(e)}
              wrapperState={this.state}
              data={data}
              summaryContent={content.find(e => e.page === 10)}
            />
          )}
          {data && data.type === 'dotSelect' && (
            <DotSelectPage
              setWrapperState={e => this.setState(e)}
              wrapperState={this.state}
              data={data}
            />
          )}
          {data && data.type === 'summary' && (
            <SummaryPage
              setWrapperState={e => this.setState(e)}
              wrapperState={this.state}
              data={data}
              resetQuiz={() => this.setState(INITIAL_STATE)}
            />
          )}
        </div>
      </React.Fragment>
    )
  }
}

export default QuizWrapper
